import { render, staticRenderFns } from "./Assess.vue?vue&type=template&id=0afaa5e2&scoped=true&"
import script from "./Assess.vue?vue&type=script&lang=js&"
export * from "./Assess.vue?vue&type=script&lang=js&"
import style0 from "./Assess.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Assess.vue?vue&type=style&index=1&id=0afaa5e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afaa5e2",
  null
  
)

export default component.exports